export const baseApi = `${process.env.REACT_APP_API_ROOT}` + "/api";